import { Button, Paper, Stack, Text, Title } from '@mantine/core';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import NextLink from 'next/link';

import { Routes } from '~/domains/common/constants/routes';

import { useIsCanada } from '../../hooks/useIsCanada';
import { PrimaryButton } from '../Button/Button';
import { Link } from '../Link/Link';

/** @deprecated in Channels we are using updated design */
export function NewToSplash() {
  const { t } = useTranslation('common');
  const isCanada = useIsCanada();

  return (
    <Paper p="xl" radius="md" withBorder sx={(theme) => ({ borderColor: theme.colors.gray[2] })}>
      <Stack spacing="md">
        <Title order={3}>{t('newToSplash.title')}</Title>
        <PrimaryButton
          component={NextLink}
          href={Routes.signUp({
            redirectTo: `${window.location.pathname}${window.location.search}`,
          })}
        >
          {t('newToSplash.signUp')}
        </PrimaryButton>
        <Button
          component={NextLink}
          href={Routes.signIn({
            redirectTo: `${window.location.pathname}${window.location.search}`,
          })}
          variant="outline"
          color="dark"
        >
          {t('newToSplash.logIn')}
        </Button>
        <Text size="xs">
          <Trans
            i18nKey="common:newToSplash.termsAndPrivacy"
            components={{
              termsLink: <Link href={Routes.termsOfUse(isCanada)} target="_blank" />,
              privacyLink: <Link href={Routes.privacyPolicy(isCanada)} target="_blank" />,
              cookiesLink: (
                <Link href="https://legal.splashsports.com/legal/cookie-notice" target="_blank" />
              ),
            }}
          />
        </Text>
        <Text size="xs">
          <Trans
            i18nKey="common:newToSplash.contestTypeAvailability"
            components={{
              link: (
                <Link
                  href="https://legal.splashsports.com/map/splash-fantasy-contest-availability"
                  target="_blank"
                />
              ),
            }}
          />
        </Text>
      </Stack>
    </Paper>
  );
}
